export const wishlistMetaState = state => state.v1.wishlistMeta;